import * as React from 'react';

import { ListProductionsViewProps } from '../../components/list/performances';
import ListPerformance from '../../components/list/performance';

const ListPerformancesView: React.StatelessComponent<ListProductionsViewProps> = props => {
    return (
        <li>
            {
                <ListPerformance key={`${props.performanceInfo.id}`}
                    performance={props.performanceInfo} performancesCount={props.performancesCount} hideDate={props.hideDate} panelOpen={props.panelOpen} />}
        </li>
    )
}

export default ListPerformancesView;